import {
    Box,
    Button,
    Checkbox,
    Flex,
    HStack,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { ICenter } from "../../models/centers.model";

import CenterService from "../../services/admin/center.service";

export const CenterModal: React.FC<any> = ({ isOpenCenter, onCloseCenter, reload, updateCenters ,centers,centersId}: { isOpenCenter: any, onCloseCenter: any, reload: any, updateCenters: any, centersId:string[], centers:ICenter[] }) => {
    const toast = useToast();
    const [centerss, setCenters] = useState<ICenter[]>([])
    const [selectedcenter, setSelectedCenters] = useState<ICenter[]>();
    const [selectedcenterId, setSelectedCentersId] = useState<string[]>();
    useEffect(() => {
        setSelectedCenters([...centers])
        if(centersId && centersId.length > 0){
            setSelectedCentersId([...centersId])
        }
        CenterService
            .getCenters(`?category=rtc`)
            .then((response) => {
                setCenters(response.data.data)
                
            })
            .catch((err) => err);
    }, []);

    const addCenters = (role: string, checked: boolean) => {
        let centersId: any[] = [];
        let centers: ICenter[] = [];
        selectedcenterId !== undefined ? centersId = [...selectedcenterId] : centersId = [];
        selectedcenter !== undefined ? centers = [...selectedcenter] : centers = [];
        if (checked) {
            centersId.push(role)
            const selectedCenter = centerss.filter((each :ICenter) => role == each.id.toString())
            const merged =[...centers,...selectedCenter]
            setSelectedCentersId(centersId)
            setSelectedCenters([...merged])
        } else if (!checked) {
            const ind = centersId.indexOf(role)
            centersId.splice(ind, 1)
            centers.splice(ind, 1)
            setSelectedCentersId(centersId)
            setSelectedCenters(centers)
        }
    
    }


    const updateCenter = () => {
        updateCenters(selectedcenter,selectedcenterId)

        toast({
            title: "Center",
            description: "Centers added successfully",
            status: "success",
        })
        onCloseCenter()
    }

    const closeModal = () => {
        setSelectedCentersId([])
        setSelectedCenters([])
        onCloseCenter()
    }

return (
    <>
        <Modal
            isOpen={isOpenCenter}
            onClose={closeModal}
            scrollBehavior="outside"
            closeOnOverlayClick={true}
            size="sm"
            isCentered
        >
            <ModalOverlay />
            <ModalContent borderRadius={5} px={3}>
                <ModalHeader>
                    <Flex justifyContent='center'>
                        <Box>
                            <Flex justifyContent='center'>
                                <Text mx='auto' color="#353535" fontSize="20px" fontWeight='800'>
                                    Add Centers
                                </Text>
                            </Flex>
                            <Text color='#9E9E9E' fontSize="14px">NB: You must select at least one center</Text>
                        </Box>
                    </Flex>

                </ModalHeader>
                <ModalCloseButton size="sm" />

                <ModalBody>
                    <Box mt={4}>


                        {
                            centerss.map(each =>
                                <HStack key={each.id} spacing={4} mb='15px'>
                                    <Checkbox colorScheme="red" name={each.name} isChecked={selectedcenterId && selectedcenterId.includes(each.id.toString())} value={each.id} onChange={(e) => addCenters(e.target.value, e.target.checked)} />
                                    <Text ml={3} color="#9E9E9E" fontSize='15px'>
                                        {each.name}
                                    </Text>

                                </HStack>)
                        }


                        <Flex mt={12} justifyContent="end">
                            <HStack>
                                <Button size="sm" px={6} fontSize={12} onClick={() => closeModal()}>
                                    Cancel
                                </Button>
                                <Button colorScheme="red" type="submit"
                                    size="sm" px={6} onClick={() => { updateCenter() }} fontSize={12} >SAVE </Button>
                            </HStack>
                        </Flex>

                    </Box>


                </ModalBody>

                <ModalFooter></ModalFooter>
            </ModalContent>
        </Modal>
    </>
);
  };
